import { Component, computed, effect, inject, signal } from '@angular/core';
import { Franchise } from 'src/app/models/franchise.model';
import { CommonModule } from '@angular/common';
import { FounderItem, FounderSlot, FoundersSelection } from '@/models/founder-item.model';
import { FoundersSlotsService } from '@/services/app/founders-slots.service';
import { OfficesService } from '@/services/api/franchises.service';
import { HigharcPlanService } from '@/services/api/higharc-plan.service';
import { HigharcOption, OptionSet } from '@/models/higharc-plan.model';

@Component({
    selector: 'app-founders-selections',
    imports: [
      CommonModule
    ],
    template: `
<div class="w-full card p-3 border-round" style="min-height: 300px;">
       
<div *ngIf="populated else noListFound">
  <div class="font-medium text-lg">Selected Options</div>
    <div class="w-full" *ngFor="let list of higharcPlanService.haPlan()?.optionSets">
        <div class="p-3 flex align-items-center cursor-pointer">
            <div class="w-full flex align-items-center pr-4">
                    <!-- <i class="pi pi-circle-on mr-3" style="font-size: 1.5rem; color: var(--primary-color)"></i> -->
                <div><span class="font-medium">{{list.name}}</span>: {{getSelected(list)}}</div>
            </div>
        </div>
    </div>
</div>
<ng-template #noListFound>
    <div class="w-full p-3 align-items-center flex flex-column mb-10" style="min-width: 90vw; min-height: 70vh;">
        <br>
        <br>
        <p class="text-500 font-bold">No Assemblies Found</p>
    <div>
    </div>
    </div>
</ng-template>
</div>
    `
})
export class FoundersSelectionsComponent {
  public higharcPlanService = inject(HigharcPlanService);

  getSelected(option: OptionSet) {
    return option.options.filter(option => option.selected)[0].name;
  }

  populated = computed(() => this.higharcPlanService.haPlan()?.optionSets);
  

}
